import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AppService } from '../../../services/app.service';

@Component({
  selector: 'app-dist-summary-chart',
  templateUrl: './dist-summary-chart.component.html',
  styleUrls: ['./dist-summary-chart.component.scss']
})
export class DistSummaryChartComponent implements OnInit {

  pies : PieOptions[] = [];
  translations: any;

  constructor(  @Inject(MAT_DIALOG_DATA) public data: any,
  public dialog: MatDialog,
  public dialogRef: MatDialogRef<DistSummaryChartComponent>,
  public appService: AppService,
) { 
  this.setPageTranslations();
  
}

  ngOnInit() {
    
    this.appService.showLoading();
    let amountData : any= [];
    let countData : any = [];
    for(let i = 0; i < this.data.length;i++){
      amountData.push({
        'OrderType' : this.data[i]['OrderType'],
        'val' : this.data[i]['TotalAmount']
      });

      countData.push({
        'OrderType' : this.data[i]['OrderType'],
        'val' : this.data[i]['TotalOrder']
      });
    }
      this.pies.push({
        'title' : 'OrderTypeAmount',
        'dataSource': amountData
      });
      this.pies.push({
        'title' : 'OrderTypeCount',
        'dataSource': countData
      });

      this.appService.hideLoading();
  }

  setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem("pageData"));
}
close() {
  this.dialogRef.close();
}
customizeLabel(arg) {
  return arg.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
}

export class PieOptions {
  title: string;
  dataSource: any;
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/distributor-order/dist-summary-chart/dist-summary-chart.component.ts